/**
 * 渲染nagbar右按钮组
 */
import {supportNative, getErrorFactory, logError} from './util';

// 下面针对租租车&探途地图(appCustomRightBarList) 和 探途旅行(renderNavbarRightPopover) 做兼容
import Detector from '../utils/detector';
const isZuzuche = Detector.browser.zuzuche;
const isTantuMap = Detector.browser.tantumap;
const nativeApiName = isZuzuche || isTantuMap ? 'appCustomRightBarList' : 'base_navbarRightPopover';

const zzc = window.zzc;


/**
 * 渲染“navbar”右侧按钮组
 * doc: https://doc.oschina.net/tantucom?t=216536
 * @export
 * @param {array} items doc文档对应的 items 属性
 * @returns Promise.resolve(true)
 */
export default function renderNavbarRightPopover(items) {
  let errorFactory = getErrorFactory(nativeApiName);

  if (!supportNative(nativeApiName)) {
    let err = errorFactory('不支持zzcjsbridge');
    return logError(err);
  }

  zzc.call(nativeApiName, {
    customItems: items,
    complete: function (res) {
      if (res.state) {
        logError(errorFactory(res.message));
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/native/renderNavbarRightPopover.js